import { Button } from '../../../atoms/Button';

const FAVORITE_BUTTON_CLASSNAME =
  'absolute right-1 top-1 z-10 h-8 w-8 border-0 bg-black/50 backdrop-blur-[2px] transition-[opacity,background-color] hover:bg-black/60 focus:bg-black/50 focus:ring-0 focus:ring-offset-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-hover active:bg-black/60 active:ring-0 active:ring-offset-0 md:opacity-0 md:focus-visible:opacity-100 md:group-focus-within:opacity-100 md:group-hover:opacity-100';

type ProductCardHorizontalBookmarkButtonProps = {
  isFavorite: boolean;
  addToFavoritesLabel: string;
  removeFromFavoritesLabel: string;
  onFavorite?: () => void;
};

export const ProductCardHorizontalBookmarkButton = ({
  isFavorite,
  addToFavoritesLabel,
  removeFromFavoritesLabel,
  onFavorite,
}: ProductCardHorizontalBookmarkButtonProps) => (
  <Button.v2
    iconLeft="BookmarkSimple"
    iconWeight={isFavorite ? 'fill' : 'bold'}
    iconSize={20}
    size="small"
    shape="square"
    variant="primary"
    className={FAVORITE_BUTTON_CLASSNAME}
    iconClassName="text-white size-5"
    aria-label={isFavorite ? removeFromFavoritesLabel : addToFavoritesLabel}
    aria-pressed={isFavorite}
    data-testid="product-card-horizontal-favorite-button"
    data-test="product-card-horizontal-favorite-button"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onFavorite?.();
    }}
  />
);
